module.exports = __webpack_public_path__ + "static/media/21_before.fb261b18.jpg";